"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceResource = exports.getMainAdminInfo = exports.getSubAdminList = exports.updateSpaceResource = exports.updateMainAdminInfo = exports.updateSubAdminListData = void 0;
const actions = __importStar(require("../../../shared/store/action_constants"));
const api_1 = require("../../../../exports/api");
const config_1 = require("../../../../config");
function updateSubAdminListData(info) {
    return {
        type: actions.UPDATE_SUB_ADMIN_LIST_DATA,
        payload: info,
    };
}
exports.updateSubAdminListData = updateSubAdminListData;
function updateMainAdminInfo(list) {
    return {
        type: actions.UPDATE_MAIN_ADMIN_INFO,
        payload: list,
    };
}
exports.updateMainAdminInfo = updateMainAdminInfo;
function updateSpaceResource(resource) {
    return {
        type: actions.UPDATE_SPACE_RESOURCE,
        payload: resource,
    };
}
exports.updateSpaceResource = updateSpaceResource;
function getSubAdminList(pageNo) {
    const pageObjectParams = {
        pageSize: config_1.ConfigConstant.SUB_ADMIN_LIST_PAGE_SIZE,
        order: config_1.ConfigConstant.ORDER_CREATE_TIME,
        sort: config_1.ConfigConstant.SORT_ASC,
    };
    return (dispatch) => {
        api_1.Api.getlistRole(JSON.stringify(Object.assign(Object.assign({}, pageObjectParams), { pageNo }))).then(res => {
            const { success, data } = res.data;
            success && dispatch(updateSubAdminListData(data));
        }, err => {
            console.error('API.getlistRole error', err);
        });
    };
}
exports.getSubAdminList = getSubAdminList;
function getMainAdminInfo() {
    return (dispatch) => {
        api_1.Api.getMainAdminInfo().then(res => {
            const { success, data } = res.data;
            success && dispatch(updateMainAdminInfo(data));
        }, err => {
            console.error('API.getMainAdminInfo', err);
        });
    };
}
exports.getMainAdminInfo = getMainAdminInfo;
function spaceResource() {
    return (dispatch) => {
        api_1.Api.getSpaceResource().then(res => {
            const { success, data } = res.data;
            success && dispatch(updateSpaceResource(data));
        }, err => {
            console.error('API.getSpaceResource', err);
        });
    };
}
exports.spaceResource = spaceResource;
//# sourceMappingURL=space_permission_manage.js.map